import { render, staticRenderFns } from "./chart-mix.vue?vue&type=template&id=3c844ea2&scoped=true&"
import script from "./chart-mix.vue?vue&type=script&lang=ts&"
export * from "./chart-mix.vue?vue&type=script&lang=ts&"
import style0 from "./chart-mix.vue?vue&type=style&index=0&id=3c844ea2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c844ea2",
  null
  
)

export default component.exports